import { get } from '../axios'

const api = `${process.env.VUE_APP_COL}/col/special`

// 保存个性化设置
export function collection_special_save(map, option) {
  return get(`${api}/save`, map, option)
}
// 查询个性化设置
export function collection_special_query(map, option) {
  return get(`${api}/query/${map}`, option)
}
